import { Translator } from '@/types/translator.type';

export const getHotelCategoryName = (t: Translator, category: string) => {
  switch (category) {
    case t('hotels.classifications.noStar'):
      return 'NONE';
    case t('hotels.classifications.oneStar'):
      return 'ONE_STAR';
    case t('hotels.classifications.twoStar'):
      return 'TWO_STAR';
    case t('hotels.classifications.threeStar'):
      return 'THREE_STAR';
    case t('hotels.classifications.fourStar'):
      return 'FOUR_STAR';
    case t('hotels.classifications.fiveStar'):
      return 'FIVE_STAR';
    case t('hotels.classifications.fiveStarLux'):
      return 'FIVE_STAR_LUXE';
    case t('hotels.classifications.palace'):
      return 'PALACE';
  }
  return 'NONE';
};

export const getHotelCategoryLabel = (t: Translator, category: string) => {
  switch (category) {
    case 'NONE':
      return t('hotels.classifications.noStar');
    case 'ONE_STAR':
      return t('hotels.classifications.oneStar');
    case 'TWO_STAR':
      return t('hotels.classifications.twoStar');
    case 'THREE_STAR':
      return t('hotels.classifications.threeStar');
    case 'FOUR_STAR':
      return t('hotels.classifications.fourStar');
    case 'FIVE_STAR':
      return t('hotels.classifications.fiveStar');
    case 'FIVE_STAR_LUXE':
      return t('hotels.classifications.fiveStarLux');
    case 'PALACE':
      return t('hotels.classifications.palace');
  }
  return t('hotels.classifications.noStar');
};
